import React, { PropsWithChildren } from 'react';

import { GenericErrorPage } from 'app/pages/generic-error/generic-error-page';

interface State {
    error?: Error;
}

class ErrorBoundary extends React.Component<PropsWithChildren, State> {
    public readonly state: State = {};

    public static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        // eslint-disable-next-line no-console
        console.warn('React component stack:', errorInfo.componentStack);
    }

    public render(): React.ReactNode {
        const { children } = this.props;

        const { error } = this.state;

        return error ? <GenericErrorPage /> : children;
    }
}

export { ErrorBoundary };
